import styled from 'styled-components';
import { TableCell } from '@mui/material';

export const StyledTableCell = styled(TableCell)({
  display: 'flex',
  flexWrap: 'nowrap',
  gap: '10px'
});

export const StyledImage = styled('img')({
  width: '100px',
  maxHeight: '60px',
  objectFit: 'contain',
});
